import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, verifyOtp, resetAuthState } from "../redux/features/loginSlice";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { useModal } from "../hooks/ModalContext";

const VerifyOtpModal = ({ isActive, onClose, onResetPassword, email }) => {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const { otpStatus, otpError } = useSelector((state) => state.auth);
  const { passwordForOtp } = useModal();

  const modalRef = useRef(null);
  const bsModal = useRef(null);

  // Initialize modal once
  useEffect(() => {
    if (!modalRef.current) return;
    bsModal.current = bootstrap.Modal.getOrCreateInstance(modalRef.current, {
      backdrop: true,
      keyboard: true,
    });

    const handleHidden = () => {
      setOtp(""); // Clear OTP field on close
      onClose?.();
    };

    modalRef.current.addEventListener("hidden.bs.modal", handleHidden);
    return () => {
      modalRef.current?.removeEventListener("hidden.bs.modal", handleHidden);
      bsModal.current = null;
    };
  }, [onClose]);

  // Show/hide modal
  useEffect(() => {
    if (!bsModal.current) return;

    if (isActive) {
      setOtp(""); // reset OTP every time modal opens
      bsModal.current.show();
    } else {
      bsModal.current.hide();
    }
  }, [isActive]);

  // OTP success → next step
  useEffect(() => {
    if (otpStatus !== "success" || !bsModal.current) return;

    bsModal.current.hide();

    modalRef.current.addEventListener(
      "hidden.bs.modal",
      () => {
        if (passwordForOtp) {
          // Auto-login after registration
          dispatch(loginUser({ email, password: passwordForOtp }));
        } else {
          // Forgot Password → open Reset Password modal
          onResetPassword?.();
        }
        dispatch(resetAuthState()); // Reset OTP state
      },
      { once: true }
    );
  }, [otpStatus, email, passwordForOtp, dispatch, onResetPassword]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!otp.trim()) return;
    dispatch(verifyOtp({ email, otp }));
  };

  return (
    <div className="modal fade" ref={modalRef} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Verify OTP</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => bsModal.current?.hide()}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Enter OTP</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={otpStatus === "loading"}
              >
                {otpStatus === "loading" ? "Verifying..." : "Verify"}
              </button>

              {otpError && <p className="text-danger mt-2">{otpError}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtpModal;
